export const BASEURL = "https://dashboard.pluralcode.com/api";
// export const BASEURL = " http://127.0.0.1:8000/api";

// Contact
export const CONTACT = BASEURL + "/contact_enquiries/new";

export const VERIFY = BASEURL + "/payments/verify";

// api/utils.js
export const VERIFY_PAYMENT_LINK = BASEURL + "/verify-payment-link";

// Blogs
export const BLOGS = BASEURL + "/blogs";

// QUESTIONNARIRES
export const QUESTIONNARIRES = BASEURL + "/questionnaires";

// QUESTIONNARIRES
export const QUESTIONNAIRES_SUBMIT = BASEURL + "/questionnaires/submit";

// Case Studies
export const CASE_STUDIES = BASEURL + "/case_studies";

// Webinar feedback
export const WEBINAR_FEEDBACK = BASEURL + "/submit-webinar-feedback";

export const LEAD_MAGNET = BASEURL + "/lm";
export const DOWNLOAD_LEAD_MAGNET = BASEURL + "/lm/download";

export const NEWSLETTER = BASEURL + "/newsletter/subscribe";

export const UNSUBSCRIBE = BASEURL + "/unsubscribe";


export const VERIFYAttendes = BASEURL + "/registeration";

export const SOMETHING_WENT_WRONG = "Something went wrong";

// API Wrappers
export const returnOrThrow = async (resJSON) => {
  let result;
  const status = resJSON.status;
  if (status === 404 || status >= 500) {
    throw `${SOMETHING_WENT_WRONG}!`;
  } else if (status === 401) {
    throw "sessionTimeout";
  }
  try {
    result = await resJSON.json();
  } catch (err) {
    result = { error: SOMETHING_WENT_WRONG };
  }
  if (status !== 200) {
    throw result.error;
  }
  return result;
};

const getHeadersObject = () => {
  return {
    "Content-Type": "application/json",
    // "ngrok-skip-browser-warning": "69420",
  };
};

export const getToken = () => {
  const token = localStorage.getItem("Token");
  return token;
};
const getHeadersFileObject = () => {
  const token = getToken();
  return {
    Authorization: `${token}`,
    // "Content-Type": "multipart/form-data",
  };
};
export const getWrapper = async (url, body = {}) => {
  const headers = getHeadersObject();
  const resJSON = await fetch(url, {
    method: "GET",
    headers,
  });
  return resJSON;
};

export const postWrapper = async (url, body, fileUpload = false) => {
  const headers = fileUpload ? getHeadersFileObject() : getHeadersObject();
  const resJSON = await fetch(url, {
    method: "POST",
    body: fileUpload ? body : JSON.stringify(body),
    headers,
  });
  return resJSON;
};

// export const getQuestionnaires = async () => {
//   const resJSON = await getWrapper(QUESTIONNARIRES);
//   const result = await returnOrThrow(resJSON);
//   return result;
// };

export const getQuestionnaires = async (token, response_id) => {
  const resJSON = await getWrapper(
    `${QUESTIONNARIRES}/${token}/${response_id}/`
  );
  const result = await returnOrThrow(resJSON);
  return result;
};

export const getBlogs = async (type = "") => {
  const resJSON = await getWrapper(`${BLOGS}?type=${type}`);
  const result = await returnOrThrow(resJSON);
  return result;
};

export const getBlogDetail = async (slug) => {
  const resJSON = await getWrapper(`${BLOGS}/${slug}`);
  const result = await returnOrThrow(resJSON);
  return result;
};

export const postQuestionnaireResponseForm = async (data, responseId) => {
  const resJSON = await postWrapper(
    `${QUESTIONNAIRES_SUBMIT}/${responseId}`,
    data
  );
  const result = await returnOrThrow(resJSON);
  return result;
};

export const postNewsletterSubscription = async (data) => {
  const resJSON = await postWrapper(NEWSLETTER, data);
  const result = await returnOrThrow(resJSON);
  return result;
};

export const getLeadMagnet = async (slug, utmParams = {}) => {
   const queryString = new URLSearchParams(utmParams).toString();
  const resJSON = await getWrapper(`${LEAD_MAGNET}/${slug}?${queryString}`);
  const result = await returnOrThrow(resJSON);
  return result;
};


// export const downloadLeadMagnet = async (downloadToken) => {
//   const resJSON = await getWrapper(`${DOWNLOAD_LEAD_MAGNET}/${downloadToken}`);
//   const result = await returnOrThrow(resJSON);
//   return result;
// };

export const downloadLeadMagnet = async (slug, downloadToken) => {
  try {
    const response = await fetch(
      `${LEAD_MAGNET}/${slug}/download-ebook/${downloadToken}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!response.ok) {
      let errorMessage = "Download failed";
      try {
        const errorData = await response.json();
        errorMessage = errorData.message || errorData.error || errorMessage;
      } catch {
        errorMessage = `HTTP error! status: ${response.status}`;
      }
      throw new Error(errorMessage);
    }
    const blob = await response.blob();

    // Extract filename from Content-Disposition header if available
    const contentDisposition = response.headers.get("Content-Disposition");
    let filename = "download.pdf";

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      );
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, "");
      }
    }

    // Create a URL for the blob
    const fileUrl = window.URL.createObjectURL(blob);

    return {
      success: true,
      fileUrl: fileUrl,
      filename: filename,
      blob: blob,
    };
  } catch (error) {
    console.error("Download error:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

export const postLeadMagnetResponseForm = async (data) => {
  const resJSON = await postWrapper(
    `${LEAD_MAGNET}/${data.slug}/responses/create`,
    data
  );
  const result = await returnOrThrow(resJSON);
  return result;
};

export const postSoftwareAuditForm = async (data) => {
  const resJSON = await postWrapper(`${LEAD_MAGNET}/${data.slug}/audit`, data);
  const result = await returnOrThrow(resJSON);
  return result;
};

export const VerifyattendesForm = async (data, token, slug) => {
  const resJSON = await postWrapper(
    `${LEAD_MAGNET}/${slug}/registeration/${token}/attend`,
    data
  );
  const result = await returnOrThrow(resJSON);
  return result;
};

export const postWebinarFeedbackForm = async (data, responseId) => {
  const resJSON = await postWrapper(`${WEBINAR_FEEDBACK}/${responseId}`, data);
  const result = await returnOrThrow(resJSON);
  return result;
};

export const getCaseStudies = async (type = "") => {
  const resJSON = await getWrapper(`${CASE_STUDIES}?type=${type}`);
  const result = await returnOrThrow(resJSON);
  return result;
};

export const getCaseStudyDetails = async (slug) => {
  const resJSON = await getWrapper(`${CASE_STUDIES}/${slug}`);
  const result = await returnOrThrow(resJSON);
  return result;
};
